import { render, staticRenderFns } from "./AdRankBrandView.vue?vue&type=template&id=3b67a87f&scoped=true"
import script from "./AdRankBrandView.vue?vue&type=script&lang=js"
export * from "./AdRankBrandView.vue?vue&type=script&lang=js"
import style0 from "./AdRankBrandView.vue?vue&type=style&index=0&id=3b67a87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b67a87f",
  null
  
)

export default component.exports